<template>
  <div>
    <partHeader :title="title" :required="true">
      <div>
        <el-button type="primary" @click="add" v-show="!disabled"
          >+家庭成员</el-button
        >
      </div>
    </partHeader>
    <!-- 非编辑状态时显示信息 -->
    <div v-show="disabled">
      <el-row>
        <el-col :span="24">
          <el-table
            :data="form.homeMainMember"
            :border="true"
            style="width: 100%"
          >
            <el-table-column prop="name" label="姓名"> </el-table-column>
            <el-table-column
              prop="relationship"
              label="与本人关系"
              :formatter="formatRelationship"
            >
            </el-table-column>
            <el-table-column prop="age" label="年龄"> </el-table-column>
            <el-table-column
              prop="degree"
              label="学历"
              :formatter="formatDegree"
            >
            </el-table-column>
            <el-table-column prop="profession" label="专业"> </el-table-column>
            <el-table-column prop="companyAndPost" label="现工作单位及岗位">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>

    <!-- 编辑时显示信息 -->
    <div v-show="!disabled">
      <el-form ref="form" :model="form" :rules="rules" label-position="right">
        <el-row v-for="(item, index) in form.homeMainMember" :key="index">
          <hr v-if="index > 0" />
          <el-row v-if="item.show">
            <el-col :span="6">
              <el-form-item label="姓名：">
                {{ item.name }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="与本人关系：">
                {{ getCodeLabel("ybrgx", item.relationship) }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="年龄：">
                {{ item.age }}
              </el-form-item>
            </el-col>
            <el-col :span="2" :offset="2">
              <el-form-item label="">
                <div class="modify" @click="modify(item)">修改</div>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item label="">
                <div class="delete" @click="del(index)">删除</div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="学历：">
                {{ getCodeLabel("xl", item.degree) }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="专业：">
                {{ item.profession }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="现工作单位及岗位：">
                {{ item.companyAndPost }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-form
            :ref="'item' + index"
            :model="item"
            :rules="itemRules"
            label-position="right"
            label-width="150px"
          >
            <el-row :class="{ show: item.modified, hide: !item.modified }">
              <el-col :span="8">
                <el-form-item label="姓名：" prop="editableName">
                  <el-input
                    v-model="item.editableName"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="与本人关系：" prop="editableRelationship">
                  <el-select
                    v-model="item.editableRelationship"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options.ybrgx"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="年龄：" prop="editableAge">
                  <el-input
                    v-model="item.editableAge"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="学历：" prop="editableDegree">
                  <el-select v-model="item.editableDegree" placeholder="请选择">
                    <el-option
                      v-for="item in options.xl"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="专业：" prop="editableProfession">
                  <el-input
                    v-model="item.editableProfession"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="现工作单位及岗位："
                  prop="editableCompanyAndPost"
                >
                  <el-input
                    v-model="item.editableCompanyAndPost"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4" :offset="10">
                <el-button type="primary" @click="save(item, index)"
                  >保存</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.show {
  display: block;
}
.hide {
  display: none;
}
.modify {
  color: #2a8ae0;
  &:hover {
    cursor: pointer;
  }
}
.delete {
  color: #ff5858;
  &:hover {
    cursor: pointer;
  }
}
</style>
<script>
import partHeader from "./partHeader.vue";
import share from "@/assets/sharejs/share.js";
export default {
  props: {
    memberList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    partHeader
  },
  data() {
    return {
      title: "家庭主要成员",
      form: {
        homeMainMember: []
      },
      rules: {
        homeMainMember: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                return callback(new Error("请添加家庭主要成员"));
              }
              for (let i = 0; i < value.length; i++) {
                if (value[i].modified == true) {
                  return callback(new Error("请保存家庭主要成员"));
                }
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      itemRules: {
        editableName: [
          { required: true, message: "请填写姓名", trigger: "blur" }
        ],
        editableRelationship: [
          { required: true, message: "请填写与本人关系", trigger: "blur" }
        ],
        editableAge: [
          { required: true, message: "请填写年龄", trigger: "blur" }
        ],
        editableDegree: [
          { required: true, message: "请填写学历", trigger: "blur" }
        ],
        editableProfession: [
          { required: true, message: "请填写专业", trigger: "blur" }
        ],
        editableConpanyAndPost: [
          {
            required: true,
            message: "请填写现工作单位及岗位",
            trigger: "blur"
          }
        ]
      },
      options: {
        xl: share.get("xl"),
        ybrgx: share.get("ybrgx")
      }
    };
  },
  created() {
    if (this.memberList && this.memberList.length > 0) {
      //TODO 添加editable对应的属性
      this.form.homeMainMember = this.memberList;
    }
  },
  mounted() {
    if (!this.$route.params.isTj) {
      this.form.homeMainMember = this.item.dsjtzycy.map(item => {
        return {
          jtzycyid: item.jtzycyid,
          name: item.xm,
          relationship: item.ybrgx,
          age: item.nl,
          degree: item.xl,
          profession: item.zy,
          companyAndPost: item.xgzdwjgw,
          show: true,
          modified: false,
          editableName: item.xm,
          editableRelationship: item.ybrgx,
          editableAge: item.nl,
          editableDegree: item.xl,
          editableProfession: item.zy,
          editableConpanyAndPost: item.xgzdwjgw
        };
      });
    }
  },
  methods: {
    formatRelationship(row) {
      return share.getValue("ybrgx", row.relationship);
    },
    formatDegree(row) {
      return share.getValue("xl", row.degree);
    },
    del(index) {
      this.form.homeMainMember.splice(index, 1);
    },
    save(item, index) {
      let key = "item" + index;
      this.$refs[key][0].validate(valid => {
        if (valid) {
          item.name = item.editableName;
          item.relationship = item.editableRelationship;
          item.age = item.editableAge;
          item.degree = item.editableDegree;
          item.profession = item.editableProfession;
          item.companyAndPost = item.editableConpanyAndPost;
          item.modified = false;
          item.show = true;
        }
      });
    },
    modify(item) {
      item.modified = true;
    },
    add() {
      // this.validate();
      let item = {
        jtzycyid: "", //id
        name: "",
        relationship: "", //与本人关系
        age: "",
        degree: "", //学历
        profession: "", //专业
        companyAndPost: "", //现工作单位及岗位
        show: false,
        modified: true,
        editableName: "",
        editableRelationship: "",
        editableAge: "",
        editableDegree: "",
        editableProfession: "",
        editableConpanyAndPost: ""
      };
      this.form.homeMainMember.push(item);
    },
    validate() {
      this.validateForm();
      if (this.validated) {
        let para = {
          data_jtzycy: []
        };
        let member = this.form.homeMainMember;
        for (let i = 0; i < member.length; i++) {
          let item = {
            jtzycyid: member[i].jtzycyid,
            xm: member[i].name,
            ybrgx: member[i].relationship,
            nl: member[i].age,
            xl: member[i].degree,
            zy: member[i].profession,
            xgzdwjgw: member[i].companyAndPost
          };
          para.data_jtzycy.push(item);
        }
        para.data_jtzycy = JSON.stringify(para.data_jtzycy);
        return para;
      }
      return null;
    },
    validateForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.validated = true;
        } else {
          this.validated = false;
        }
      });
    },
    getCodeLabel(key, selectKey) {
      return share.getValue(key, selectKey);
    },
    reset() {
      this.form.homeMainMember = [];
    }
  }
};
</script>
